import * as React from 'react';

import ChestCircumferenceForm from './ChestCircumference';
import VentilationForm from './Ventilation';
import PulmonaryForm from './Pulmonary';
import { filterByDocumentType, formDataByType } from 'Utility/documentHandling';
import type { TPulmonaryDocumentType } from 'Routes/Pulmonary/utils';

const Form = ({ formData, documents, editing }: IOwnProps): React.JSX.Element | null => {
  const document = documents.find(d => d._id === editing);
  switch (document?._type) {
    case 'chestCircumference':
      return <ChestCircumferenceForm formData={formDataByType(formData, document)} />;
    case 'ventilationAid':
      return <VentilationForm formData={formDataByType(formData, document)} />;
    case 'pulmonary':
      return (
        <PulmonaryForm
          formData={formDataByType(formData, document)}
          documents={filterByDocumentType(documents, 'pulmonary')}
          editing={editing}
        />
      );
    default:
      return null;
  }
};
interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<TPulmonaryDocumentType>>;
  documents: IDocumentWithTypeV2<TPulmonaryDocumentType>[];
  editing: string;
  viewing?: boolean;
}

export default Form;
